import classNames from 'classnames';
import { FC, useRef } from 'react';
import { Transition } from 'react-transition-group';

import { Icon, Text } from '@servicetitan/anvil2';
import IconChevronRight from '@servicetitan/anvil2/assets/icons/material/round/chevron_right.svg';
import { core } from '@servicetitan/anvil2/token';

import * as Styles from './mid-call-checkin-banner.module.less';

const DURATION = 250;

interface MidCallCheckInBannerProps {
    open: boolean;
    onClick: () => void;
}

/*
 * Full-width primary-blue banner that animates in (slide down + fade) to replace the breadcrumb
 * job-title strip when a mid-call (halftime) check-in is available. Tapping it opens the mid-call
 * coaching chat. Driven by the `open` flag (TopicPickerStore.fieldProCoachingLive).
 */
export const MidCallCheckInBanner: FC<MidCallCheckInBannerProps> = ({ open, onClick }) => {
    const nodeRef = useRef(null);

    return (
        <Transition
            appear
            in={open}
            timeout={DURATION}
            mountOnEnter
            unmountOnExit
            nodeRef={nodeRef}
        >
            {state => (
                <button
                    ref={nodeRef}
                    type="button"
                    onClick={onClick}
                    data-cy="mid-call-checkin-banner"
                    style={{
                        backgroundColor: core.semantic.BackgroundColorPrimary.value,
                        transition: `transform ${DURATION}ms, opacity ${DURATION}ms`,
                    }}
                    className={classNames(Styles.banner, {
                        [Styles.bannerEntering]: state === 'entering',
                        [Styles.bannerEntered]: state === 'entered',
                        [Styles.bannerExiting]: state === 'exiting',
                        [Styles.bannerExited]: state === 'exited',
                    })}
                >
                    <Text className="t-truncate" size="small">
                        Mid-Call Check-In available. Tap to view.
                    </Text>
                    <Icon svg={IconChevronRight} />
                </button>
            )}
        </Transition>
    );
};
